import { render, staticRenderFns } from "./GodDashboard.vue?vue&type=template&id=0fb3e678&scoped=true"
import script from "./GodDashboard.vue?vue&type=script&lang=js"
export * from "./GodDashboard.vue?vue&type=script&lang=js"
import style0 from "./GodDashboard.vue?vue&type=style&index=0&id=0fb3e678&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb3e678",
  null
  
)

export default component.exports